// extracted by mini-css-extract-plugin
export default {"Chose_Container":"chose_Chose_Container__MgX+-","line":"chose_line__ar+OG","l":"chose_l__Lehwi","destaque":"chose_destaque__xUS27","bckg":"chose_bckg__leiYR"};